import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  heading: {
    textAlign: "center",
    fontSize: 16,
    fontFamily: "Helvetica-Bold",
    textTransform: "uppercase",
    paddingBottom: 12,
  },
  status: {
    color: "#403E92",
  },
  info: {
    marginBottom: 12,
    paddingBottom: 6,
    borderBottomWidth: 1,
    borderBottomColor: "#403E92",
    borderBottomStyle: "solid",
  },
  row: {
    flexDirection: "row",
    marginBottom: 3,
  },
  label: {
    fontFamily: "Helvetica-Bold",
    fontSize: 9,
    color: "#403E92",
    width: 100,
  },
  value: {
    fontSize: 9,
    flexGrow: 1,
    flexBasis: 0,
  },
});

// Title + date range / status block at the top of an export PDF.
// `meta` comes from buildExportMeta.
const PdfExportHeader = ({ meta }) => (
  <>
    <View style={styles.heading}>
      <Text>
        {meta.title} - <Text style={styles.status}>{meta.status}</Text>
      </Text>
    </View>
    <View style={styles.info}>
      <View style={styles.row}>
        <Text style={styles.label}>Date Range</Text>
        <Text style={styles.value}>{meta.dateRange}</Text>
      </View>
      <View style={styles.row}>
        <Text style={styles.label}>Status</Text>
        <Text style={styles.value}>{meta.statusLabel}</Text>
      </View>
    </View>
  </>
);

export default PdfExportHeader;
